import api from './api'

/** Túneis VPN auxiliares por link WAN (multi-link A/B/C), tabela managed_device_vpn_links. */
export const vpnLinksApi = {
  getByDevice: async (deviceId) => {
    const response = await api.get(`/managed-devices/${deviceId}/vpn-links`)
    return response.data
  },

  create: async (deviceId, data) => {
    const response = await api.post(`/managed-devices/${deviceId}/vpn-links`, data)
    return response.data
  },

  update: async (deviceId, linkId, data) => {
    const response = await api.patch(`/managed-devices/${deviceId}/vpn-links/${linkId}`, data)
    return response.data
  },

  delete: async (deviceId, linkId) => {
    const response = await api.delete(`/managed-devices/${deviceId}/vpn-links/${linkId}`)
    return response.data
  },
}
